module.exports = __webpack_public_path__ + "img/logo-horizontal_white.b9d93117.png";